/**
 * BrandsMarquee.tsx — Gold Garage Door / Brands · Section 6/8
 * Cream · infinite logo marquee (all 12, doubled) · gold edge fades · pause on hover.
 * MOBILE: real <style> media queries (speed + size).
 * 10WEB AI: keep <img> + <style> keyframes. Wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const INK = "#1A1F2E";
const CREAM = "#FAF7F1";
const BRANDS = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/b5706f1be_58dae4e4d_BD_Australia_Logo.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/24bd15fa9_a095621ff_Merlin-Logo-Positive.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/7656bc9c2_c348bc03e_gliderol-logo.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/liftmaster.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/steel-line-garage-doors.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/marantec.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/grifco.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/ata-logo-min-300x226.png.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/5e385702d_6c94e3d82_superliftlogo-1.png", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/centurion-garage-doors.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/hormann.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/doors-industrial.webp"];
const LOOP = [...BRANDS, ...BRANDS];
export default function BrandsMarquee() {
  return <section id="brands-marquee" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    paddingTop: "4.5rem",
    paddingBottom: "4.5rem"
  }}>
      <style>{`
        @keyframes bm-scroll { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
        .bm-track { display: flex; align-items: center; width: max-content; animation: bm-scroll 38s linear infinite; }
        .bm-track:hover { animation-play-state: paused; }
        .bm-track img { height: 34px; width: auto; object-fit: contain; padding: 0 2.25rem; flex-shrink: 0; opacity: 0.85; }
        @media (max-width: 600px) {
          .bm-track { animation-duration: 24s; }
          .bm-track img { height: 26px; padding: 0 1.4rem; }
          #brands-marquee { padding-top: 3rem; padding-bottom: 3rem; }
        }
        @media (prefers-reduced-motion: reduce) { .bm-track { animation: none; } }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.4,
      pointerEvents: "none",
      mixBlendMode: "multiply"
    }}><filter id="paper-bm"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" stitchTiles="stitch" /><feColorMatrix type="matrix" values="0 0 0 0 0.85, 0 0 0 0 0.82, 0 0 0 0 0.74, 0 0 0 0.08 0" /></filter><rect width="100%" height="100%" filter="url(#paper-bm)" /></svg>

      <div style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem 2rem",
      position: "relative",
      zIndex: 1,
      textAlign: "center"
    }}>
        <span style={{
        fontFamily: "'Manrope', sans-serif",
        fontSize: "0.72rem",
        fontWeight: 700,
        letterSpacing: "0.16em",
        color: GOLD_DARK,
        textTransform: "uppercase"
      }}>Trusted Across Sydney</span>
        <h2 style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontWeight: 800,
        fontSize: "clamp(1.5rem, 5vw, 2.2rem)",
        color: NAVY,
        lineHeight: 1.15,
        margin: "0.6rem 0 0"
      }}>One crew for every name on the door</h2>
      </div>

      <div style={{
      position: "relative",
      overflow: "hidden",
      zIndex: 1
    }}>
        <div aria-hidden style={{
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        width: "90px",
        background: `linear-gradient(90deg, ${CREAM}, transparent)`,
        zIndex: 2,
        pointerEvents: "none"
      }} />
        <div aria-hidden style={{
        position: "absolute",
        right: 0,
        top: 0,
        bottom: 0,
        width: "90px",
        background: `linear-gradient(270deg, ${CREAM}, transparent)`,
        zIndex: 2,
        pointerEvents: "none"
      }} />
        <div className="bm-track">
          {LOOP.map((src, i) => <img key={i} src={src} alt="" width={120} height={34} loading="lazy" decoding="async" />)}
        </div>
      </div>

      <div style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "2rem 1.5rem 0",
      position: "relative",
      zIndex: 1,
      textAlign: "center"
    }}>
        <p style={{
        fontFamily: "'Manrope', sans-serif",
        fontSize: "0.9rem",
        color: INK
      }}>
          Don't see your brand? Call <a href="tel:0485000933" style={{
          color: NAVY,
          fontWeight: 800,
          textDecoration: "none",
          borderBottom: `2px solid ${GOLD}`
        }}>0485 000 933</a>.
        </p>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>
    </section>;
}